import React from 'react';
import { cloneDeep, split, trim, get } from 'lodash';

// local dependencies
import { paymentCardActivation as PaymentCardActivationView } from 'ui/views/widgets/paymentCardActivation';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PaymentCardActivation } from 'ui/containers/PaymentCardActivation';
 *
 * // render
 * <PaymentCardActivation propName='propValue'/>
 */
export class PaymentCardActivation extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            card: this.props.card,
            showError: true,

            editMode: false,
            expiryMonth: '',
            expiryYear: ''
        };

        this.handleEditActionClick = this.handleEditActionClick.bind( this );
        this.handleCancelEdit = this.handleCancelEdit.bind( this );
        this.handleCardMonthSelect = this.handleCardMonthSelect.bind( this );
        this.handleCardYearSelect = this.handleCardYearSelect.bind( this );
        this.handleSubmitEditedDate = this.handleSubmitEditedDate.bind( this );
        this.handleToggleHsaFsa = this.handleToggleHsaFsa.bind( this );
    }

    handleEditActionClick() {
        log.debug( 'PaymentCardActivation.handleEditActionClick()' );

        const [ expiryMonth, expiryYear ] = split( this.state.card.expDate, '/' );

        this.setState( {
            editMode: true,
            expiryMonth: trim( expiryMonth ),
            expiryYear: trim( expiryYear )
        } );
    }

    handleCancelEdit() {
        log.debug( 'PaymentCardActivation.handleCancelEdit()' );

        this.setState( {
            editMode: false,
            expiryMonth: '',
            expiryYear: ''
         } );
    }

    handleCardMonthSelect( { value } ) {
        log.debug( 'PaymentCardActivation.handleCardMonthSelect()' );

        this.setState( { expiryMonth: value } );
    }

    handleCardYearSelect( { value } ) {
        log.debug( 'PaymentCardActivation.handleCardYearSelect()' );

        this.setState( { expiryYear: value } );
    }

    async handleSubmitEditedDate() {
        log.debug( 'PaymentCardActivation.handleSubmitEditedDate()' );

        this.props.onSubmitEditedDate( {
            card: this.props.card,
            month: this.state.expiryMonth,
            year: this.state.expiryYear
        }, () => {
            const card = cloneDeep( this.state.card );
            card.expDate = `${ this.state.expiryMonth }/${ this.state.expiryYear }`;

            this.setState( {
                card,
                editMode: false,
                showError: false
            } );
        } );
    }


    // Handles hsaFsa Toggle on card
    async handleToggleHsaFsa( { url } ) {
        log.debug( 'PaymentCardActivation.handleToggleHsaFsa()' );

        const card = cloneDeep( this.state.card );

        this.props.onHsaFsaActionToggle( { url, id: card.id, flags: card.flags }, () => {

            card.flags.isHsaFsa = ! get( card, 'flags.isHsaFsa', false );

            this.setState( {
                card
            } );
        } );
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <PaymentCardActivationView
                { ...this.props }
                { ...this.state }
                actions={ this.props.actions }
                onEditActionClick={ this.handleEditActionClick }
                onCancelEdit={ this.handleCancelEdit }
                onCardMonthSelect={ this.handleCardMonthSelect }
                onCardYearSelect={ this.handleCardYearSelect }
                onSubmitEditedDate={ this.handleSubmitEditedDate }
                onToggleHsaFsa={ this.handleToggleHsaFsa }
            />
        );
    }
}

// set display name
PaymentCardActivation.displayName = 'PaymentCardActivation';

// set default props
PaymentCardActivation.defaultProps = {};

// prop types
PaymentCardActivation.propTypes = {};
